import api from "../api";
import axios from "../utils/axios.instance";
import handleError from "./handle-error";

export const getTotalEarningAndWithdraw = async () => {
    try {
        const { data } = await axios.get(api.totalEarningAndWihdraw);
        return data;
    } catch (err) {
        throw handleError(err);
    }
};

export const getPotentialEarnings = async () => {
    try {
        const { data } = await axios.get(api.potentialEarning);
        return data;
    } catch (err) {
        throw handleError(err);
    }
};

export const getPendingEarnings = async () => {
    try {
        const { data } = await axios.get(api.pendingEarning);
        return data;
    } catch (err) {
        throw handleError(err);
    }
};

export const getJobPostingFee = async () => {
    try {
        const { data } = await axios.get(api.jobPostingFee);
        return data;
    } catch (err) {
        throw handleError(err);
    }
};

interface GetWithdrawalHistoriesParams {
    limit?: number
    page?: number
}

export const getWithdrawalHistories = async ({
    limit = 30,
    page = 1
}: GetWithdrawalHistoriesParams = {}) => {
    try {
        const params = new URLSearchParams()
        if (limit) params.append('limit', limit?.toString())
        if (page) params.append('page', page?.toString())
        const URL = params ? api.withdrawalHistories + `?${params?.toString()}` : api.withdrawalHistories
        const { data } = await axios.get(URL);
        return data;
    } catch (err) {
        throw handleError(err);
    }
};

export const refundPayment = async (payload) => {
    try {
        const { data } = await axios.post(api.paymentRefund, payload);
        return data;
    } catch (err) {
        throw handleError(err);
    }
};
